const sunHourFields = [
  'sunlight_e', 'sunlight_n', 'sunlight_ne', 'sunlight_nw',
  'sunlight_s', 'sunlight_se', 'sunlight_sw', 'sunlight_w'
]

export {
  sunHourFields
}